const doc = [({"en":({"js":({"admin":({"highscores":({"index":({"the_highscore_was_deleted":"The highscore was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;